import React from "react";
import { SecSubTitle, SecTitle, ProgressOne } from "../../components";

const AboutTwo = ({ ...restProps }) => (
  <div {...restProps}>
    <div className="container">
      <div className="row flex-row-reverse">
        <div className="col-lg-5 col-xxl-auto mb-30 pb-20 pb-lg-0">
          <img src="/images/skill/skill-1-1.jpg" alt="Skill" />
        </div>
        <div className="col-lg-7 col-xxl-6 me-xl-auto">
          <SecSubTitle>
            <i className="fas fa-user-graduate" /> Transform Knowledge Into
            Real-World Expertise
          </SecSubTitle>
          <SecTitle className="h1">
            Unlock Your Professional Potential With Future-Ready SAP Skills
          </SecTitle>
          <p className="mb-4 pb-1">
            Our training programs go beyond theory — they are built around real
            business processes, case studies, and simulation environments that
            replicate live SAP systems. Each participant gains end-to-end
            visibility of enterprise operations, from finance and logistics to
            analytics and HR management.
          </p>
          <ProgressOne title="Real-World Project Simulations" now={92} />
          <ProgressOne title="Industry-Aligned Curriculum" now={89} />
          <ProgressOne title="Placement & Career Support" now={93} />
          <ProgressOne title="Global SAP Certification Success Rate" now={95}/>

        </div>
      </div>
    </div>
  </div>
);

export default AboutTwo;
